<template>
  <div class="con">
    <ImageCard
      v-for="(x, i) in list"
      :class="{ completion: x.comple, half: !x.comple }"
      :key="i"
      v-bind="x"
    ></ImageCard>
  </div>
</template>

<style scoped>
.completion {
  width: calc(100% - 16px) !important;
  margin-left: 8px;
  float: left;
}
.half {
  width: calc((100% - 32px) / 2) !important;
  float: left;
  margin-right: 8px;
  margin-left: 8px;
}
</style>

<script>
import ImageCard from "@/components/ImageCard.vue";
export default {
  components: {
    ImageCard
  },
  data() {
    return {
      list: [
        {
          path: require("@/assets/company/company1.jpg"),
          title: "世有科技输变电智能化在线监测控制系统生产基地及科研楼全景图",
          comple: true
        },
        {
          path: require("@/assets/company/evn1.jpg"),
          title: "生产基地",
          comple: false
        },
        {
          path: require("@/assets/company/evn2.jpg"),
          title: "办公楼",
          comple: false
        },
        {
          path: require("@/assets/company/evn5.jpg"),
          title: "技术中心研发团队",
          comple: true
        },
        {
          path: require("@/assets/company/evn3.jpg"),
          title: "变压器油色谱在线监测系统组装调试区域",
          comple: true
        },
        {
          path: require("@/assets/company/evn4.jpg"),
          title: "变压器油色谱在线监测系统测试老化区域",
          comple: true
        },
        {
          path: require("@/assets/company/evn8.jpg"),
          title:
            "智能设备状态监测装置、局部放电在线监测装置、铁芯接地电流监测装置、避雷器在线监测装置车间",
          comple: true
        },
				{
					path: require("@/assets/company/evn15.jpg"),
					title:
						"智能化检测中心",
					comple: false
				},
				{
					path: require("@/assets/company/evn16.jpg"),
					title:
						"智能化检测中心",
					comple: false
				},
				{
          path: require("@/assets/company/evn14.jpg"),
          title:
            "光纤测温装置装配区域",
          comple: true
        },
        {
          path: require("@/assets/company/evn13.jpg"),
          title:
            "光纤测温装置调试区域",
          comple: true
        },
				{
          path: require("@/assets/company/evn19.jpg"),
          title:
            "光纤测温装置检验区域",
          comple: true
        },
        {
          path: require("@/assets/company/evn10.jpg"),
          title: "智慧物联网",
          comple: false
        },
        {
          path: require("@/assets/company/evn6.jpg"),
          title: "激光焊接车间",
          comple: false
        },
				{
					path: require("@/assets/company/evn18.jpg"),
          title: "温控器生产区域",
          comple: false
				},
				{
					path: require("@/assets/company/evn17.jpg"),
          title: "温控器检验区域",
          comple: false
				},
				{
				  path: require("@/assets/company/evn12.jpg"),
				  title: "温控器检验区域",
				  comple: true
				},
        {
          path: require("@/assets/company/evn7.jpg"),
          title: "变压器用温控器、油位计生产车间",
          comple: true
        }
      ]
    };
  }
};
</script>
